import { useContext } from 'react';

import SeasonalCard from '@/components/game/ui/card/SeasonalCard';
import SummitCard from '@/components/game/ui/card/SummitCard';
import { GameContext, ViewContext } from '@/state/contexts';
import { performActionType } from '@/type/performAction';
import { logg } from '@/util/logg';
import { SummitMeta } from '@lc/card/meta/SummitMeta';
import '@/style/HandModal.css';
import {
	summitTypeWinter as winter,
	// summitTypeTurn as turn,
} from '@lc/const/modifiers';
import { advanceSummitResolution, playSummitCard } from '@lc/const/socketEvent';
import { createActionParams } from '@lc/interface/actionParams/factory';

/**
 * Winter Summit Resolution Step Decisions
 *
 * Whether to play their next resolving Contract or Award (NEXT), OR any Winter Summit cards
 *
 * NEXT on no contracts/awards is skip
 */

/*
  TODO NEXT WINTER SUMMIT

  -Implement advance & resolve next summit contract award on server
  -On decision return to player for resolution, re-advance reasonably
  -Scour hands to delete all summit cards that are not on turn winter summit cards
  -make sure the summit cards are playable?
  -make sure you can get to endgame
*/
const DecisionSummitWinterModal = ({
	activeContractsAndAwards,
	summitCards,
}) => {
	const { performAction }: any = useContext(GameContext); //currPlayer,
	const { toggleMinimize }: any = useContext(ViewContext);

	const performActionTyped = performAction as performActionType;

	function playCard(e, cardId) {
		e.preventDefault();
		logg(playSummitCard);
		const actionParams = createActionParams(cardId);
		performActionTyped(playSummitCard, actionParams);
		// onClose();
	}

	return (
		<div className="modal">
			<div className="modal-content">
				<span className="close" onClick={toggleMinimize}>
					&minus;
				</span>
				<h2 className="modal-title"></h2>
				<div className="hand">
					{activeContractsAndAwards.map((cardId) => (
						<div className="card">
							<SeasonalCard
								cardId={cardId}
								width={0}
								height={0}
							/>
						</div>
					))}
				</div>
				<h2 className="modal-title">Winter Summit Cards</h2>
				{summitCards.length > 0 && (
					<div className="hand">
						{summitCards.map((cardId) => (
							<div className="card">
								{cardId && logg(cardId)}
								<SummitCard
									cardId={cardId}
									width={0}
									height={0}
								/>
								{SummitMeta[cardId].type === winter && (
									<button
										value={0}
										onClick={(e) => playCard(e, cardId)}
									>
										Play Card
									</button>
								)}
							</div>
						))}
					</div>
				)}
				<button
					value={0}
					onClick={
						() => performActionTyped(advanceSummitResolution)
						// sendDecisionAdvanceSummitResolution(currPlayer)
					}
				>
					Next
				</button>
			</div>
		</div>
	);
};

export default DecisionSummitWinterModal;
